import { render, staticRenderFns } from "./QuestionsAnswersheet.vue?vue&type=template&id=368e04aa&scoped=true"
import script from "./QuestionsAnswersheet.vue?vue&type=script&lang=js"
export * from "./QuestionsAnswersheet.vue?vue&type=script&lang=js"
import style0 from "./QuestionsAnswersheet.vue?vue&type=style&index=0&id=368e04aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e04aa",
  null
  
)

export default component.exports